import { render, staticRenderFns } from "./WikiCustomHeader.vue?vue&type=template&id=5542797a"
import script from "./WikiCustomHeader.vue?vue&type=script&lang=ts"
export * from "./WikiCustomHeader.vue?vue&type=script&lang=ts"
import style0 from "./WikiCustomHeader.vue?vue&type=style&index=0&id=5542797a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports